import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { BOX_SHADOWS, DATA_TYPES, FONTS, PRIMARY_COLOR } from "../../constants";
import { convertToNumber } from "../../helpers/DataHelpers";
import { formatNumber } from "../../helpers/FormatNumber";
import { stateType } from "../../state";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "row",
      width: "98.5%",
      backgroundColor: "white",
      boxShadow: BOX_SHADOWS,
      borderRadius: "10px",
      height: "80px",
      fontFamily: FONTS,
      marginBottom: "20px",
      flex: 1,
      overflow: "auto",
      justifyContent: "space-between",
    },
    preTitle: {
      fontFamily: FONTS,
      color: "rgba(0,0,0,0.4)",
      marginTop: "10px",
      marginLeft: "20px",
    },
    var: {
      fontFamily: FONTS,
      fontSize: "24px",
      fontWeight: "bold",
      marginLeft: "20px",
      marginTop: "5px",
    },
    predVal: {
      fontFamily: FONTS,
      fontSize: "23px",
      fontWeight: "bold",
      marginRight: "10px",
      lineHeight: "80px",
      color: PRIMARY_COLOR,
    },
    predVal2: {
      fontFamily: FONTS,
      fontSize: "15px",
      marginRight: "40px",
      lineHeight: "80px",
      color: "rgba(0,0,0,.5)",
      marginTop: "3px",
    },
  })
);

export function PredictedValueBox({ state }: stateType) {
  const classes = useStyles();

  const col = state.saveState.dataset.getColumn(
    state.saveState.modelTraining.valueToPredict
  );
  if (col === undefined) {
    return <div></div>;
  }
  const isNumeric = col.columnType === DATA_TYPES.number;

  let predicted =
    state.saveState.personaPrediction.personas[
      state.saveState.personaPrediction.personaselected
    ].predicted;
  if (isNumeric) {
    predicted = formatNumber(convertToNumber(predicted));
  }
  return (
    <div className={classes.container}>
      <div>
        <div className={classes.preTitle}>Predicted value for</div>
        <div className={classes.var}>
          {state.saveState.modelTraining.valueToPredict}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className={classes.predVal}
          style={{ marginRight: isNumeric ? "30px" : "20px" }}
        >
          {predicted}
        </div>
      </div>
    </div>
  );
}
